import { Input } from 'components';
import { Session, RecruitmentBy, useRecruitment } from '@app/api';
import { useFormikContext } from 'formik';
import { EditablePlanIncentive } from './EditablePlanIncentive';
import { useTranslation } from 'react-i18next';
import { CountryIncentiveDisplay } from './CountryIncentiveDisplay';
import { Theme } from '@app/theme';
import { createUseStyles } from 'react-jss';

interface Props {
  session: Session;
}

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    marginTop: theme.marginBase * 3,
  },
}));

export const IncentiveField = ({ session }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const formik = useFormikContext<{ duration?: number }>();

  const { data: recruitment } = useRecruitment(session.recruitmentId);

  const duration =
    formik && formik.values.duration
      ? formik.values.duration
      : session.duration;

  if (!session.planId) {
    return (
      <Input
        name="incentiveText"
        label={t('sessions.display.incentiveText')}
        placeholder={t('sessions.placeholder.incentiveText', { amount: 2500 })}
        noBottomMargin
      />
    );
  }

  if (session.planId && recruitment?.recruitmentBy === RecruitmentBy.CLIENT) {
    return <EditablePlanIncentive session={session} />;
  }

  return (
    <CountryIncentiveDisplay
      session={session}
      label={t('sessions.display.incentiveText')}
      duration={duration}
      className={classes.container}
    />
  );
};
